<template>
  <form class="nameform m-center" @submit="submit">
    <div class="content flex flex-wrap">
      <h1 class="mb-6">Carta Prepagata</h1>

      <div class="w-full mb-3" v-for="term in cardTerms.filter(c => c.radio === false)" :key="term.id">
        <a class="link" @click="openTerm(term.id)">{{ term.description }}</a>
      </div>

      <!-- TODO: check this loop out! we can have multiple items (?) and just one checkbox model (privacyConsentRead) -->
      <!-- TODO: is that correct? -->
      <div class="w-full mt-3" v-for="term in cardTerms.filter(c => c.mandatory && c.radio === true)" :key="term.id">
        <div class="tnb-checkbox">
          <div class="inline-flex">
            <span class="asterisk">*</span>
            <input type="checkbox" id="privacyConsentRead" v-model="term.checked"
              @change="toggleCheckbox('privacyConsentRead')" />
            <label for="privacyConsentRead">{{ term.description }}</label>
          </div>
        </div>
        <div class="f-r text-grey flex items-center mt-2" style="font-size: 11px; color: red;">
          <span class="asterisk">*</span>
          Campo obbligatorio
        </div>
      </div>

      <div class="w-full mt-3" v-for="term in nonMandatoryTerms" :key="term.id">
        <p class="text-grey mb-3">{{ term.description }}</p>
        <div class="tnb-input tnb-radio">
          <label :for="term.id">Dai il consenso</label>
          <div>
            <div class="tnb-radio-container mr-8">
              <input type="radio" id="yes" :name="term.id" :value="true" v-model="term.checked" />
              <label for="yes">Si</label>
            </div>
            <div class="tnb-radio-container">
              <input type="radio" id="no" :name="term.id" :value="false" v-model="term.checked" />
              <label for="no">No</label>
            </div>
          </div>
        </div>
      </div>

      <div class="w-full mb-5 mt-5" v-for="document in cardDocuments" :key="document.id">
        <div class="outline-link" :class="{ read: document.read }" @click="openStaticContract(document)">
          <div class="outline-link__text">{{ document.description }}</div>
          <div class="outline-link__status">
            {{ document.read ? "Letto" : "Leggi per proseguire" }}
          </div>
        </div>
        <div class="mt-3" v-if="document.read">
          <div class="tnb-checkbox">
            <div class="inline-flex">
              <input type="checkbox" id="generalConditionRead" @change="toggleCheckbox('generalConditionRead')" />
              <label for="generalConditionRead">Dichiaro di aver preso visione dei Documenti precontrattuali e
                condizioni generali</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-footer">
      <button class="btn" type="submit" :disabled="$v.$invalid">
        Prosegui
      </button>
    </div>
  </form>
</template>

<script>
import { sameAs } from "vuelidate/lib/validators";
import DocumentsService from "@/services/DocumentsService";
import RegistrationService from "@/services/RegistrationService";
import UtilityService from "@/services/UtilityService";
import store from "@/store";

export default {
  name: "CardDocumentation",
  data() {
    return {
      cardTerms: [],
      privacyTerm: {},
      nonMandatoryTerms: [],
      cardDocuments: [],
      flowDocs: [],
      privacyConsentRead: false,
      generalConditionRead: false,
      viewedDocumentation: false,
      staticContractRead: false
    };
  },
  validations: {
    privacyTerm: {
      checked: {
        sameAs: sameAs(() => true)
      }
    },
    generalConditionRead: {
      sameAs: sameAs(() => true)
    },
    cardDocuments: {
      // Custom validation function to check if all 'read' properties are true
      readProperties: function (value) {
        if (value.every(doc => doc.read === true)) {
          return true;
        }
        else return false;
      }
    }
  },
  computed: {
    appReady() {
      return store.state.appReady;
    }
  },
  mounted() {
    if (this.appReady) {
      this.init();
    } else {
      this.$root.$on(`storeUpdated@setAppReady`, state => {
        if (state.appReady) {
          this.init();
        }
      });
    }
  },
  methods: {
    init() {
      DocumentsService.getTerms().then(response => {
        this.cardTerms = response.terms
          .filter(
            t =>
              t.id === 120 ||
              t.id === 121 ||
              t.id === 122 ||
              t.id === 123 ||
              t.id === 124
          )
          .map(c => {
            c.checked = false;
            return c;
          });

        this.privacyTerm = this.cardTerms.filter(t => t.id === 121)[0];
        this.nonMandatoryTerms = this.cardTerms.filter(
          c => c.mandatory === false && c.radio === true
        );
      });

      DocumentsService.getStaticContracts().then(response => {
        this.cardDocuments = response.staticContracts.filter(
          d => d.type === "UNICO_CSI"
        ).map(d => {
          d.read = false;
          return d;
        })
      });
    },
    toggleCheckbox(checkboxKey) {
      this[checkboxKey] = !this[checkboxKey];
    },
    openTerm(id) {
      DocumentsService.openTerm(id);
      /* } */
    },
    openStaticContract(document) {
      document.read = true;
      var url = DocumentsService.getStaticContractUrlFromId(document.documentId);
      DocumentsService.openDocument(url);
    },

    submit() {
      event.preventDefault();
      if (this.loading) return;
      this.loading = true;

      const radios = this.cardTerms.filter(t => t.radio === true);
      const req = {
        acceptedTermIds: radios.filter(r => r.checked).map(r => r.id),
        rejectedTermIds: radios.filter(r => !r.checked).map(r => r.id)
      };

      RegistrationService.setTerms(req).then(
        () => {
          this.stepCompleted();
        },
        error => {
          //TODO: error handling
          console.log(error);
          this.loading = false;
          UtilityService.showDefaultError(error);
        }
      );
    },
    async stepCompleted() {
      if (this.$store.state.user.minor) {
        await RegistrationService.upgradeRegistrationProgress(3);
        this.$root.$emit("submitStep");
      } else {
        this.$root.$emit("submitStep");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.asterisk {
  color: red;
  margin-right: 10px;
  font-size: 18px;
}

.tnb-radio {
  align-items: center;
  label {
    margin: 0;
  }
}
</style>
